import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { Button } from "@/shared/ui/Button";

type Props = {
    className?: string;
    teamId: string;
};

export const UpgradeTariffButton = ({ className, teamId }: Props) => {
    const { t } = useTranslation();
    const handleUpgradeTariffButtonClick = () => {
        // TODO: сделать сразу ссылкой?
        if (!teamId) return;
        window.open(`${canv.host}/dashboard?need_tariff_payment=true&teamId=${teamId}`, "_blank");
    };

    return (
        <Button className={className} variant="secondary" onClick={handleUpgradeTariffButtonClick}>
            {t("updateTariff.action")}
        </Button>
    );
};
